// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__mufAw","box":"WorkspacesBox_box__2ZTgt","node":"WorkspacesBox_node__2X8dh"};